import styled from 'styled-components';

import { SEMANTIC_COLORS } from '../../../constant/unit/color';
import { DEVICE } from '../../../constant/unit/device';

export const S = {
  Wrapper: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    min-height: 100vh;
    padding: 20px;
    background: ${SEMANTIC_COLORS.DEFAULT_PAGE_BACKGROUND};

    @media ${DEVICE.mobileM} {
      padding: 30px 20px 36px;
    }
  `,
  Img: styled.img`
    max-width: 100%;
    max-height: 120px;

    @media ${DEVICE.mobileM} {
      max-height: 180px;
    }
  `,
  Content: styled.div`
    @media ${DEVICE.mobileM} {
      width: calc(100% - 66px);
    }

    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    align-items: center;
    width: calc(100% - 20px);
    margin-bottom: 20px;
  `,
  Title: styled.div`
    width: 100%;
    padding: 10px 0;
    font-size: 20px;
    line-height: 29px;
    color: ${SEMANTIC_COLORS.ERROR_TEXT};
  `,
  Text: styled.div`
    width: 100%;
    padding-bottom: 10px;
    line-height: 19px;
    color: ${SEMANTIC_COLORS.DEFAULT_TEXT};
    border-bottom: 1px solid rgb(93 134 90 / 50%);
  `,
  Message: styled.div`
    width: 100%;
    min-height: 65px;
    max-height: 120px;
    margin-top: 12px;
    overflow-y: auto;
    line-height: 19px;
    color: ${SEMANTIC_COLORS.DEFAULT_TEXT};
  `,
  Link: styled.a`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 126px;
    height: 41px;

    font-size: 20px;
    font-weight: 700;
    color: ${SEMANTIC_COLORS.PRIMARY_BUTTON_TEXT};

    background: ${SEMANTIC_COLORS.PRIMARY_BUTTON_BACKGROUND};
    border: 2px solid ${SEMANTIC_COLORS.PRIMARY_BUTTON_BACKGROUND};
    border-radius: 21.5px;
  `,
};
